import axiosInstance from "./axiosInstance";
const API_URL = "/follow";

const createFollow = async (follower_id, following_id, following_username) => {
  try {
    const response = await axiosInstance.post(
      `${API_URL}/create_follow`,
      {
        follower_id,
        following_id,
        following_username,
      },
      {
        withCredentials: true,
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error while posting", error);
    throw error;
  }
};

const getFollowers = async (username) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/get_followers`, {
      params: { username },
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching posts:", error);
    throw error;
  }
};

const getFollowing = async (username) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/get_followings`, {
      params: { username },
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching posts:", error);
    throw error;
  }
};

const getFollowSuggestion = async (user_id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/get_follow_suggestion`, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching posts:", error);
    throw error;
  }
};

// const mutualFollowing = async () => {
//   try {
//     const response = await axios.get(`${API_URL}/get_following_posts`, {
//       withCredentials: true,
//     });
//     return response.data;
//   } catch (error) {
//     console.error("Error fetching posts:", error);
//     throw error;
//   }
// };

const deleteFollow = async (follower_id, following_id, following_username) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/delete_follow`, {
      data: { follower_id, following_id, following_username },
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting followers:", error);
    throw error;
  }
};

export {
  getFollowers,
  getFollowing,
  getFollowSuggestion,
  createFollow,
  deleteFollow,
  // mutualFollowing,
};
